module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 15.06 15.06"
    }
  }, [_c('title', [_vm._v("green_tick")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Layer_2",
      "data-name": "Layer 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Layer_3",
      "data-name": "Layer 3"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.53,15.06A7.53,7.53,0,1,0,0,7.53,7.53,7.53,0,0,0,7.53,15.06ZM4,5.52l2.7,2.7,4.54-4.54,1.66,1.66-6.2,6.21L2.38,7.18Z",
      "fill": "#93c13e"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-edb74cbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/icons/CheckMarkIcon.vue
// module id = 3392
// module chunks = 0